<template>
  <div class="im">
    <el-card class="left">
      <div class="title">客户列表<el-tag :type="getSocketStatusTagType()" size="mini">{{ getSocketStatusText() }}</el-tag></div>
      <div style="display: flex;justify-content: space-between;">
        <el-input size="small" clearable v-model="input"></el-input>
        <el-button @click="handleSearch" style="min-height: 32px;height: 32px;max-height: 32px;line-height: 8px;" type="primary">搜索</el-button>
      </div>
      <div class="left-list">
        <div v-for="(item,index) in lList" :key="index" :class="leftObj.id === item.id ? 'left-item active' : 'left-item'">
          <el-badge :value="item.unReadCount" :hidden="item.unReadCount === 0" :max="99" class="item-badge">
            <img :src="item.avatar" alt="" @click.stop="handleLeft(item)">
          </el-badge>
          <div class="name">
            <div class="">{{item.name}}</div>
            <el-input style="width: 200px;" size="mini" v-model="item.remark" @blur.stop="handleRemark(item)"></el-input>
          </div>
        </div>
      </div>
    </el-card>
    <el-card class="right" v-if="leftObj.name">
      <div class="right-top-flex">
        <div class="top">
          <img class="top-img" :src="leftObj.avatar" alt="">
          <div class="name">{{ leftObj.name }}</div>
        </div>
        <div> <el-button @click="handleDu" size="small" type="primary" plain>已读</el-button></div>
      </div>
      <!-- @scroll="handleScroll" -->
      <div class="right-content" ref="scrollContainer">
        <div class="r-item" v-for="(item,index) in rList" :key="index">
          <!-- 我方发送给对方的 -->
          <div v-if="item.fromType == '1'" class="ours">
            <div class="ours-item">
              <div class="ours-time">{{ getTime(item.timestamp) }}</div>
              <div v-if="item.messageType == '0'" class="ours-text">{{item.content}}</div>
              <div v-if="item.messageType == '2'" class="ours-file" @click="handleLoad(item)">
                <div><i class="el-icon-download"></i>{{ jsonObj(item.extend, 'fileName') }}</div>
              </div>
              <el-image
                  @click="jsonObj(item.extend, 'url')"
                  :src="jsonObj(item.extend, 'url')"
                  fit="fill"
                  :preview-src-list="[jsonObj(item.extend, 'url')]"
                  v-if="item.messageType == '1'"
                  class="ours-img"
              />
            </div>
            <!-- 我方头像 -->
            <img src="@/assets/gm.jpg" alt="" class="ours-portrait">
          </div>
          <!-- 对方发送给我方的 -->
          <div v-if="item.fromType == '0'" class="adverse">
            <!-- 对方头像 -->
            <img :src="leftObj.avatar" alt="" class="adverse-portrait">
            <div class="adverse-item">
              <div class="adverse-time">{{ getTime(item.timestamp) }}</div>
              <div v-if="item.messageType == '0'" class="adverse-text">{{item.content}}</div>
              <div v-if="item.messageType == '2'" class="adverse-file" @click="handleLoad(item)">
                <div><i class="el-icon-download"></i>{{ jsonObj(item.extend, 'fileName') }}</div>
              </div>
              <el-image
                  @click="jsonObj(item.extend, 'url')"
                  :src="jsonObj(item.extend, 'url')"
                  fit="fill"
                  :preview-src-list="[jsonObj(item.extend, 'url')]"
                  v-if="item.messageType == '1'"
                  class="adverse-img"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="right-bottom">
        <el-input
            v-model="textarea"
            :rows="3"
            type="textarea"
            placeholder="请输入发送内容"
        />
        <div class="right-flex">
          <div class="flex">
            <el-upload
                :http-request="handleUploadImg"
                action=""
                multiple
                :show-file-list="false"
                accept=".png,.jpg,.jpeg,.svg"
            >
              <el-button size="small" type="primary" plain>上传图片</el-button>
            </el-upload>
<!--            <el-upload-->
<!--                :http-request="handleUploadFile"-->
<!--                action=""-->
<!--                multiple-->
<!--                :show-file-list="false"-->
<!--                accept=".xls,.xlsx,.pdf,.doc,.docx,.xlsm"-->
<!--                class="ml5"-->
<!--            >-->
<!--              <el-button size="small" type="primary" plain>上传文件</el-button>-->
<!--            </el-upload>-->
          </div>
          <el-button @click="handleSend" size="small" type="success">发送消息</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import { useChatSocket } from './useChatSocket'
import { getTime } from "@/assets/js/utils";

export default {
  name: "Im-no",
  data() {
    return {
      input: "",
      textarea: "",
      lList: [],
      rList: [],
      ws: null,
      state: null,
      url: process.env.VUE_APP_WSS + "?type=line&token=" + window.sessionStorage.getItem('token').split(' ')[1],
      globalsObj: {},
      leftObj: {},
      getTime,
      scrollTop: 0 // 用于保存滚动距离
    }
  },
  watch: {
    // 监听消息（对方发送）
    'state.messages': {
      handler(newVal) {
        console.log('接收数据message======',newVal)
        if(newVal && newVal.length > 0) {
          // 新消息进入
          if(newVal[newVal.length - 1].message.fromId === this.leftObj.id){
            this.rList.push(newVal[newVal.length - 1].message)
          }
          // 更新左侧列表
          if(newVal[newVal.length - 1].code == 4){
            this.initLeftList();
          }
          // 处理未读的数量数据
          this.setLeftList(newVal[newVal.length - 1].message)
        }
      },
      deep: true,
      // immediate: true,
    },
    // 监听聊天列表更新，自动滚动到底部
    rList: {
      handler() {
        this.scrollToBottom();
      },
      deep: true
    }
  },
  created() {
    const { connect, disconnect, sendMessage, state } = useChatSocket(this.url)
    this.ws = { connect, disconnect, sendMessage }
    this.state = state
    this.ws.connect()
  },
  mounted() {
    this.scrollToBottom();
    this.initGlobals();
    this.initLeftList();
  },
  methods: {
    // 获取WebSocket连接状态文本
    getSocketStatusText() {
      // 首先检查网络状态
      if (!this.state.isOnline) {
        return '网络断开';
      }
      
      if (!this.state.socket) return '未连接';
      switch (this.state.readyState) {
        case WebSocket.CONNECTING:
          return '连接中...';
        case WebSocket.OPEN:
          return '已连接';
        case WebSocket.CLOSING:
          return '断开中...';
        case WebSocket.CLOSED:
          return '已断开';
        default:
          return '未知状态';
      }
    },
    // 获取WebSocket状态对应的tag类型
    getSocketStatusTagType() {
      // 首先检查网络状态
      if (!this.state.isOnline) {
        return 'danger'; // 网络断开使用红色
      }
      
      if (!this.state.socket) return 'info'; // 未连接使用灰色
      switch (this.state.readyState) {
        case WebSocket.CONNECTING:
          return 'warning'; // 连接中使用橙色
        case WebSocket.OPEN:
          return 'success'; // 已连接使用绿色
        case WebSocket.CLOSING:
          return 'warning'; // 断开中使用橙色
        case WebSocket.CLOSED:
          return 'danger'; // 已断开使用红色
        default:
          return 'info'; // 未知状态使用灰色
      }
    },
    async handleRemark(row){
      const params = {
        friendId: row.id,
        remark: row.remark,
      }
      const res = await this.$http.put( `/im/friends`, params)
      if(res.data.code === 200){
        await this.initLeftList();
      }
    },
    async setLeftList(newVal) {
      /*if(newVal.fromId === this.leftObj.id){
        const res = await this.$http.get( `/im/lineFriends/clean?cusId=${this.leftObj.id}`)
        if(res.data.code === 200){
          await this.initLeftList();
        }
      }else {
        await this.initLeftList();
      }*/
      await this.initLeftList();
    },
    async handleSearch() {
      const params = {
        name: this.input,
      }
      const res = await this.$http.post("/im/lineFriends", params)
      this.lList = res.data.data
    },
    handleScroll() {
      const container = this.$refs.scrollContainer;
      if (container) {
        this.scrollTop = container.scrollTop;
        console.log('距离顶部：', this.scrollTop);
      }
    },
    async initGlobals(){
      const res = await this.$http.get("/im/lineAdmin")
      this.globalsObj = res.data.data
    },
    async initLeftList(){
      const res = await this.$http.post("/im/lineFriends")
      this.lList = res.data.data
      console.log('左侧列表=====',res.data.data)
      let num = 0
      for (let i = 0; i < this.lList.length; i++) {
        num += this.lList[i].unReadCount;
      }
      this.$store.commit('setLineCount', num);
    },
    // 上传图片
    async handleUploadImg(file) {
      let formData = new FormData()
      formData.append('file', file.file)
      const res = await this.$http.post("/aliyun/oss/upload",formData)
      const extend = JSON.stringify({
        fileName: file.file.name,
        url: res.data.data,
      })
      const params = {
        code: '2',
        message: {
          chatId: this.leftObj.id,
          extend,
          fromId: this.globalsObj.id,
          fromType: '1',
          messageType: '1',
          type: '0',
          userId: this.leftObj.userId,
          timestamp: new Date().getTime(),
        },
      }
      await this.ws.sendMessage(JSON.stringify(params))
      this.rList.push(params.message)
      await this.clearNumber()
      // const res = await $axios.post('/aliyun/oss/upload', formData)
    },
    // 上传文件
    async handleUploadFile(file) {
      let formData = new FormData()
      formData.append('file', file.file)
      const res = await this.$http.post("/aliyun/oss/upload",formData)
      const extend = JSON.stringify({
        fileName: file.file.name,
        url: res.data.data,
      })
      const params = {
        code: '2',
        message: {
          chatId: this.leftObj.id,
          extend,
          fromId: this.globalsObj.id,
          fromType: '1',
          messageType: '2',
          type: '0',
          userId: this.leftObj.userId,
          timestamp: new Date().getTime(),
        },
      }
      this.ws.sendMessage(JSON.stringify(params))
      this.rList.push(params.message)
    },
    // 点击左侧
    async handleLeft(item) {
      // item.unReadCount = 0
      this.leftObj = item
      // 获取右侧历史列表数据
      const params = {
        chatId: item.id,
        fromId: this.globalsObj.id,
        type: '0',
        pageSize: 300,
      }
      const res = await this.$http.get("/im/messages", {params})
      this.rList = res.data.data
      await this.initLeftList();

    },
    scrollToBottom() {
      this.$nextTick(() => {
        setTimeout(() => {
          const container = this.$refs.scrollContainer;
          if (container) {
            container.scrollTop = container.scrollHeight;
          }
        }, 200); // 延迟 50ms 等待 DOM 渲染完成
      });
    },
    // 点击已读
    async handleDu(){
      await this.clearNumber()
    },
    // 发送文本消息
    async handleSend() {
      if (this.textarea.trim()) {
        const params = {
          code: '2',
          message: {
            chatId: this.leftObj.id,
            // 去掉回车的换行符
            content: this.textarea.replace(/\n+$/, ""),
            fromId: this.globalsObj.id,
            fromType: '1',
            messageType: '0',
            type: '0',
            userId: this.leftObj.userId,
            timestamp: new Date().getTime(),
          },
        }
        await this.ws.sendMessage(JSON.stringify(params))
        this.rList.push(params.message)
        this.textarea = ''
        await this.clearNumber()
      }
    },
    // 处理json 图片文件数据
    jsonObj(json, key){
        try {
          if (json) {
            let a = JSON.parse(json)
            return a[key]
          } else {
            return ''
          }
        } catch (err) {
          return ''
        }
     },
    // 没次发送消息的时候都要先清除未读，再去拉取左边显示未读
    async clearNumber(){
      const res = await this.$http.get(`/im/lineFriends/clean?cusId=${this.leftObj.id}`)
      if(res.data.code === 200){
        await this.initLeftList();
      }
    },
    handleLoad(item) {
      const params = JSON.parse(item.extend);
      window.open(params.url, '_blank');
    },
    // 链接
    connect() {
      this.ws.connect()
    },
    // 断开链接
    disconnect() {
      this.ws.disconnect()
    }
  },
  beforeDestroy() {
    this.ws.disconnect()
  },
}
</script>
<style scoped lang="less">
.im{
  display: flex;
  height: calc(100% - 30px);
  .left{
    width: 340px;
    height: 100%;
    min-width: 340px;
    max-width: 340px;
    .title{
      font-size: 19px;
      font-weight: bold;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      
      .el-tag {
        margin-left: 8px;
      }
    }
    .el-input{
      margin-bottom: 10px;
    }
    .left-list{
      height: calc(100% - 80px);
      overflow-y: auto;
      .left-item{
        width: 100%;
        height: 66px;
        background: #ecf5ff;
        margin-bottom: 15px;
        margin-top: 10px;
        display: flex;
        align-items: center;
        border: 3px solid #f2f3f5;
        box-sizing: border-box;
        &.active{
          border: 3px solid #e99135;
        }
        .item-badge{
          position: relative;
          left: 0;
          width: 66px;
          height: 66px;
          cursor: pointer;
          img{
            width: 66px;
            height: 62px;
            margin-top: 2px;
          }
        }

        .name{
          margin-left: 10px;
          div{
            margin-bottom: 5px;
          }
        }
      }
    }
  }
  .right{
    flex: 1;
    margin-left: 10px;
    .right-top-flex{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 10px;
      border-bottom: 1px solid #ecf5ff;
      .top{
        display: flex;
        .top-img{
          width: 60px;
          height: 60px;
        }
        .name{
          margin-left: 20px;
        }
      }

    }
    .right-content{
      height: calc(100% - 190px);
      overflow-y: auto;
      padding-bottom: 10px;
      padding-top: 10px;
      border-bottom: 1px solid #ecf5ff;
      .r-item{
        .ours{
          width: 80%;
          display: flex;
          align-items: flex-start;
          justify-content: flex-end;
          margin: 10px 0 10px 20%;
          .ours-item{
            position: relative;
          }
          .ours-portrait{
            margin-right: 10px;
          }
          .ours-text{
            width: auto;
            height: auto;
            border: 1.5px solid #7dc647;
            padding: 5px;
            border-radius: 5px 0 5px 5px;
            color: #7dc647;
            background: #fff;
            word-break: break-word;
            margin-right: 10px;
            margin-top: 17px;
            white-space: pre-wrap;
          }
          .ours-time{
            width: 145px;
            position: absolute;
            right: 10px;
            white-space: nowrap;
            top: -4px;
          }
          .ours-file{
            width: auto;
            height: auto;
            border: 1.5px solid #7dc647;
            padding: 5px;
            border-radius: 5px 0 5px 5px;
            color: #7dc647;
            background: #fff;
            word-break: break-word;
            margin-right: 10px;
            cursor: pointer;
            margin-top: 17px;
            div{
              display: flex;
              align-items: center;
            }
          }
          .ours-img{
            width: 260px;
            margin-right: 10px;
            margin-top: 17px;
          }
        }
        .adverse{
          width: 80%;
          display: flex;
          align-items: flex-start;
          margin: 10px 0;
          .adverse-item{
            position: relative;
          }
          .adverse-time{
            position: absolute;
            top: -4px;
            left: 0;
            width: 145px;
            white-space: nowrap;
          }
          .adverse-portrait{
            margin-right: 10px;
          }
          .adverse-text{
            width: auto;
            height: auto;
            margin-top: 17px;
            border: 1.5px solid #7dc647;
            padding: 5px;
            border-radius: 0 5px 5px 5px;
            color: #fff;
            background: #7dc647;
            word-break: break-word;
            white-space: pre-wrap;
          }
          .adverse-file{
            width: auto;
            height: auto;
            margin-top: 17px;
            border: 1.5px solid #7dc647;
            padding: 5px;
            border-radius: 0 5px 5px 5px;
            color: #fff;
            background: #7dc647;
            word-break: break-word;
            cursor: pointer;
            div{
              display: flex;
              align-items: center;
            }
          }
          .adverse-img{
            width: 260px;
            margin-top: 17px;
          }
        }
        img{
          width: 40px;
          height: 40px;
        }
      }
    }
    .right-bottom{
      margin-top: 10px;
      .right-flex{
        margin-top: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .flex{
          display: flex;
        }
      }
    }
  }
}

::v-deep .el-card__body{
  height: 100%;
}
.ml5{
  margin-left: 5px;
}
</style>